import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { ManageGeneralMarketsComponent } from '../manage-general-markets.component';

@Component({
    selector: 'app-add-general-market',
    templateUrl: './add-general-market.component.html',
    standalone: false
})
export class AddGeneralMarketComponent implements OnInit {

  generalMarket: GeneralMarketInitial;

  constructor(private service: AppService, private translate: TranslateService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient, public dialogRef: MatDialogRef<ManageGeneralMarketsComponent>) { }

  ngOnInit() {
    this.InitializeForm();
  }

  /** Cancel button event */
  OnCancel() {
    this.dialogRef.close(0);
  }

  /** Save button event */
  OnSaveAccount() {
    if (this.generalMarket.code && this.generalMarket.description) {
      this.service.showSpinner();
      this.http.post<GRSSResponse>(this.baseUrl + 'api/generalMarkets/addGeneralMarket', this.generalMarket).subscribe(result => {
        let navigated = false;
        if (result.statusCode === 1) {
          this.dialogRef.close(1);
        } else if (result.statusCode === 4) {
          navigated = true;
          this.dialogRef.close(1);
          this.service.SaveStatus(true, 'Markets.General.Messages.msgHeaderNewMarket', result.statusMessage);
        }

        if (!navigated) {
          this.service.SaveStatus(false, 'Markets.General.Messages.msgHeaderNewMarket', result.statusMessage);
        }
      }).add(() => {
        this.service.hideSpinner();
      });
    }
  }

  /** Initializes the form values */
  InitializeForm() {
    this.generalMarket = {
      code: '',
      description: ''
    };
  }

}

/** Interface for access new general market form details */
interface GeneralMarketInitial {
  code: string;
  description: string;
}

